module.exports = __webpack_public_path__ + "media/What.c27e4fca.mp4";